window.onload = function () {
	const container = document.querySelector('.container');
	const svg = document.querySelector('.cursor-progress');
	const progressBar = document.querySelector('.progress-bar');
	const pct = document.querySelector('.pct');
	// const totalLength = progressBar.getTotalLength();
	let r = progressBar.getAttribute("r");
	let radius = (2 * Math.PI * r) + '';

	setTopValue(svg);

	progressBar.style.strokeDasharray = radius;
	progressBar.style.strokeDashoffset = radius;

	window.addEventListener('scroll', () => {
		setProgress(progressBar, radius);
	});

	window.addEventListener('resize', () => {
		setTopValue(svg);
	});
};

function setTopValue(svg) {
	svg.style.top = document.documentElement.clientHeight * 0.5 - (svg.getBoundingClientRect().height * 0.5) + 'px';
}


function setProgress(progressBar, totalLength) {
	const clientHeight = document.documentElement.clientHeight;
	const scrollHeight = document.documentElement.scrollHeight;
	const scrollTop = document.documentElement.scrollTop;

	const percentage = scrollTop / (scrollHeight - clientHeight);


	progressBar.style.strokeDashoffset = (totalLength - totalLength * percentage) + '';
}
